export default __webpack_public_path__ + "static/media/ico-neptune-db-score-low.9e20a75c.svg";